export default __webpack_public_path__ + "static/media/African_marketPlace.348f6cb1.webp";